
export default {
  name: 'ALoader',
  props: {
    message: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    errorMessage: 'Lo sentimos no se ha podido obtener la información.',
  }),
};
